export type TInvoiceUploadTab = 'pending' | 'uploaded';

export enum EInvoiceUploadStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface IInvoiceUploadError {
  description?: string;
}

export interface IInvoiceUpload {
  uuid: string;
  createdAt: string;
  invoiceDate?: string | null;
  invoiceNumber?: string | null;
  supplierCode?: string | null;
  supplierName?: string | null;
  confirmationNumber?: string | null;
  bookingReference?: string | null;
  currency?: string | null;
  amount?: string | null;
  confidence?: string | null;
  errors: IInvoiceUploadError[];
  status: EInvoiceUploadStatus;
}

export interface IInvoiceUploadsQueryParams {
  tab: TInvoiceUploadTab;
  offset: number;
  limit: number;
}

export interface IInvoiceUploadsSearchFilter {
  statuses?: EInvoiceUploadStatus[];
}

export interface IInvoiceUploadsSearchRequest {
  filter?: IInvoiceUploadsSearchFilter;
  pagination?: { offset: number; limit: number };
}

export interface IInvoiceUploadsResponse {
  pagination: { offset: number; limit: number };
  count: number;
  imports: IInvoiceUpload[];
}

export interface IInvoiceUploadFileUrlResponse {
  url: string;
}
